export default __webpack_public_path__ + "static/media/TMDB.bb8aa703.svg";